export enum SystemMarketEnum {
    CRYPTO = 'crypto',
    PRODUCT = 'product',
    FIAT = 'fiat'
}
